<template>
    <div id="batchSection" class="app-inner">
          <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="openSub('ruleForm')"
            >
             保存
           </el-button>
            </div>
               <div class="edit-from">
                  <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex">
                 <div class="public-tit flex align-cen">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  基本信息
                    </div>
                </div>
                     <el-form-item label="小节标题：" prop="headline">
                         <el-input v-model="form.headline" placeholder="请输入小节标题" clearable></el-input>
                    </el-form-item>
         <el-form-item label="设置试听课：">
                    <el-radio v-model="form.trial" label="0">否</el-radio>
                    <el-radio v-model="form.trial" label="1">是</el-radio>
                </el-form-item>
                   <el-form-item label="排序：" >
                         <el-input v-model="form.sort" placeholder="请输入小节排序" clearable></el-input>
                    </el-form-item>
                  </el-form>
         </div>
          <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 课程文件
                      </div>
                     <div class="mft public-btn-small">
                     <div class="public-btn-small-primary" @click="openTeam(1)">
                          素材库上传         
                    </div>
                </div>
              </div>
                 <div class="importTopic" v-if="relationList.length == 0">
            <el-upload 
            accept="" drag   
            :auto-upload="true" 
             :action="$config.baseUrl + '/admin/sys-file/upload'" 
              :headers="headers"
             :on-success="handleSuccess"
             :on-remove="handleRemove"
              ref="uploadRef"  
             :file-list="oneList"
             :on-change="handleChange"
              >
                <i class="icon-al-file-fill"></i>
                <div class="el-upload__text">
                   课程文件拖拽到此区域上传，或<em>选择文件上传</em>
                </div>
               <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
            <div class="tips-text">
                <div class="title">上传说明</div>
                <p style="margin-top:17px">
                <p v-if="$route.query.headId">已上传课程文件：<span style="color:red">{{wj}}</span></p>
                支持视频、音频、文档、图片上传，限单文件
                </p>
            </div>
        </div>
               <!-- 人员 -->
        <div class="team-tab" v-if="relationList && relationList.length">
                <el-table
            :data="relationList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column label="文件名称" align="center" prop="fileName">
         </el-table-column>
           <el-table-column prop="fileSize" label="大小" align="center">
             <template slot-scope="scope">
                <div>
                    {{scope.row.fileSize | kbToMb}}
                </div>
             </template>
         </el-table-column>
          <el-table-column  label="文件类型" align="center" prop="type">
          </el-table-column>
               <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
             <template slot-scope="scope">
            <el-button type="text" size="small" style="color:red" @click="deletPro(scope.row)">取消选择</el-button>
             </template>
             </el-table-column>
         </el-table>
        </div>
                <!-- 学习课件上传 -->
            <div class="public-tit flex align-cen" ref="materials" style="margin-top:20px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 学习课件
                      </div>
                        <div class="mft public-btn-small" style="margin-right:20px">
                     <div class="public-btn-small-primary" v-if="isShow == 2" @click="isShow = 1">
                          手动上传         
                    </div>
                </div>
                     <div class="public-btn-small" style="padding-left:0">
                     <div class="public-btn-small-primary" @click="openTeam(2)">
                          素材库上传    
                    </div>
                </div>
              </div>
         <div class="importTopic" v-if="isShow == 1">
            <el-upload 
            accept="" drag   
            :auto-upload="true" 
             :action="$config.baseUrl + '/admin/sys-file/upload'" 
              :headers="headers"
             :on-success="handleSuccess1"
             :on-remove="handleRemove1"
             :file-list="fileList1"
             multiple
              ref="upload"  
              >
                <i class="icon-al-file-fill"></i>
                <div class="el-upload__text">
                   课程文件拖拽到此区域上传，或<em>选择文件上传</em>
                </div>
               <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
            <div class="tips-text">
                <div class="title">上传说明</div>
                <p style="margin-top:17px">
                 <p v-if="$route.query.headId">已上传学习文件：<span style="color:red">{{wj1}}</span></p>
                <p>支持 doc，docx，wps，ppt，pptx，pdf, html,bt，xls，xlsx 格式的文件上传,且文件大小不能超过 200 MB.</p>
                <p>所有文档类型，请确保文档内容不为空，否则文档可能转化失败，</p>
                <p>为了达到更好的浏览效果，该文档需要花费几分钟的时间进行转码，请耐心等待。</p>
                </p>
            </div>
        </div>
              <!-- 人员 -->
        <div class="team-tab" v-if="isShow == 2">
                <el-table
            :data="relationList1"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column label="文件名称" align="center" prop="fileName">
         </el-table-column>
           <el-table-column prop="fileSize" label="大小" align="center">
             <template slot-scope="scope">
                <div>
                    {{scope.row.fileSize | kbToMb}}
                </div>
             </template>
         </el-table-column>
          <el-table-column  label="文件类型" align="center" prop="type">
          </el-table-column>
               <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
             <template slot-scope="scope">
            <el-button type="text" size="small" style="color:red" @click="deletPro1(scope.row)">取消选择</el-button>
             </template>
             </el-table-column>
         </el-table>
        </div>
          <el-dialog
  title="选择素材"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
   @close="reback1"
  >
         <div class="forminfo"> 
    <teamTemplate
     :temParms="'materialLibrary'"
     :type="isTemType"
     @sendStatus="classSelect"
    ref="teamTem"
    ></teamTemplate>
       <div class="authbtn flex align-cen">
             <el-button plain @click="reback1">取消</el-button>
              <el-button type="primary"  @click="onSubmit1">确认选择</el-button>
        </div>
  </div>
          </el-dialog>
    </div>
</template>
<script>
import {courseChapterList,editcourseHelpChapter,courseChapterDetail} from "@/api/index/index"  //章节列表、新增章节、章节详情
import teamTemplate from "@/views/Course/materialLibrary/index.vue"; //将素材库页面作为组件使用
export default {
     components:{
        teamTemplate,
    },
    data () {
        return {
            isShow:1,
            oneList:[],
            wj:'',
            wj1:'',
            dataparam:{},
            isTemType:'',
            relationList:[],
            relationList1:[],
            selectList:[],
            centerDialogVisible:false,
            fileList:'',
            fileList1:[],
            headers:{},
            loading:false,
            list:[],
            form:{
                sort:'',
                headline:'',
                courseId:'',
                parentId:'',
                content:'',
                document:'',
                materials:'',
                trial:'',
                materialList:[]
            },
             rules:{
              headline: [{ required: true, message: '请输入章节标题', trigger: 'blur' }],
            }
        }
    },
    created() {
        this.form.courseId = this.$route.query.id
        this.form.parentId = this.$route.query.chapterId
          if(this.$route.query.headId){
                this.getDetail()
                    }
     let token = this.$locaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
     // 文件状态改变时的钩子
    handleChange(file, fileList) {
      // 限制只能有一个文件，新文件替换旧文件
      if (fileList.length > 1) {
        this.oneList = [fileList[fileList.length - 1]]; // 只保留最后一个文件
      }
    },
             // 获取详情
        getDetail(){
              courseChapterDetail({
                id:this.$route.query.headId
              },'get')
            .then(res => {
               this.form = res.data
               this.wj = res.data.document
               this.wj1 = res.data.materials || ''
               console.log(res.data.materials)
               this.form.materialList = []
               this.form.materials = ''
            })
            .catch(err => {
            })
        },
        // 保存批量新增章节
         openSub(formName){
            this.form.materialList = []
                if (this.fileList) {
                    this.form.materialList.push(this.fileList);
                }
                    if (this.fileList1 && this.fileList1.length) {
                        this.fileList1.forEach(item => {
                            // 确保 response.data 存在
                            if (item?.response?.data) {
                                this.form.materialList.push(item.response.data);
                            }
                        });
                    }
             if(!this.form.document) return this.$util.Notifi('请上传课程文件或从素材库中选择上传','error','fa-exclamation-circle');
            
               if(this.wj1){
                this.form.materials = `${this.wj1},${this.form.materials}`
               }
            let params = { ...this.form};
            let method = "post"
             if(!this.$route.query.headId) params = {...this.form},method = "post";
            if(this.$route.query.headId) params = {...this.form,id:this.$route.query.headId}, method = "put";
              this.$refs[formName].validate((valid) => {  
                     if(valid){
                         this.commentBness(params,method)
                     }
              })
         },
                commentBness(params,method){
               this.loading = true
                editcourseHelpChapter(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.headId) this.$message.success('新增成功')
                                setTimeout(() => {
                           this.$router.push({
                            name: "twoCourse",
                                query:{
                                    twoId:this.$route.query.id,
                                }
                           })
                             }, 100);
                           }else{
                             this.loading = false
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
           // 取消选择
        deletPro(data){
                let arr = []
                arr.push(data)
             let delet= this.relationList.filter(item=>!arr.some(ele=>ele.id===item.id))
            this.relationList = delet
        },
           // 取消选择
        deletPro1(data){
                let arr = []
                arr.push(data)
             let delet= this.relationList1.filter(item=>!arr.some(ele=>ele.id===item.id))
            this.relationList1 = delet
             let str1 = this.fileList1.map(item => item.response.data.url)
             let str2 = this.relationList1.map(item => item.url)
             this.form.materials = [...str1,...str2].join(',')
        },
         // 打开选择窗口
        openTeam(type){
            let that = this
             this.centerDialogVisible = true  
             this.isTemType = type
                   this.$nextTick(function () {   
                    if(type == 1){
                        that.$refs.teamTem.editfun(that.relationList)    
                    }else{
                        that.isShow = 2
                        that.$refs.teamTem.editfun(that.relationList1)    
                    }
             })
        },
       // 确认选择
        onSubmit1(){
          if(this.isTemType == 1){
              if(this.selectList.length > 1) return this.$util.Notifi('课程文件只能选择一个','error','fa-exclamation-circle') 
                this.relationList = this.selectList
                this.fileList = ''
                this.form.document = this.relationList.map(item => item.url).join(',')
          }else if(this.isTemType == 2){
             this.relationList1 = this.selectList
             let str1 = this.fileList1.map(item => item.response.data.url)
             let str2 = this.relationList1.map(item => item.url)
             this.form.materials = [...str1,...str2].join(',')
          }
           this.centerDialogVisible = false
        },
         classSelect(val,val1){
           this.selectList = val
        },  
               // 文件上传成功
        handleSuccess(res, file,fileList){
           this.form.document = res.data.url
           this.fileList = res.data
           this.oneList = fileList; 
        },
               // 文件上传成功
        handleSuccess1(res, file,fileList){
           this.fileList1 = fileList
            let str1 = this.fileList1.map(item => item.response.data.url)
             let str2 = this.relationList1.map(item => item.url)
              this.form.materials = [...str1,...str2].join(',')
        },
          handleRemove(res,file, fileList){
         this.form.document  = ''
         this.fileList = ''
         this.oneList = fileList; 
      },
        handleRemove1(res,file, fileList){
         this.fileList1 = fileList
          let str1 = this.fileList1.map(item => item.response.data.url)
            let str2 = this.relationList1.map(item => item.url)
             this.form.materials = [...str1,...str2].join(',')
      },
                // 获取章节列表
        chapterList(){
              courseChapterList({
                id:this.$route.query.id
              })
            .then(res => {
                
                if(res.code == 0){
                  if(res.data !==null){
                    this.list = res.data
                  }else{
                    this.list = []
                  }
                }
            })
            .catch(err => {
            })
        },
        // 返回
        reback(){
        this.$router.push({
            name: "twoCourse",
            query:{
                twoId:this.$route.query.id,
            }
           })
        },
        // 取消素材选择
        reback1(){
              this.$refs['teamTem'].remove()  
             this.centerDialogVisible = false  
        },
    },
     filters: {
        kbToMb(value) {
            return (value / 1024 / 1024).toFixed(2) + ' MB'
        }
        }
}
</script>
<style lang="scss" scoped>
#batchSection{
    margin-bottom: 70px;
}
.importTopic{
    width: 100%;
    text-align: center;
    padding-top: 0px;
    box-sizing: border-box;
    .template-text{
        display: flex;
        align-items: center;
    justify-content: center;
    color: #7a8c99;
    font-size: 14px;
    cursor: pointer;
    padding-top: 20px;
.excel-icon{
        display: inline-block;
    width: 20px;
    height: 20px;
    background: url('../../../assets/images/excel-deactivate.svg') center no-repeat;
}
    }
    .tips-text{
   background-color: #f2f9fe;
    padding: 25px 10px 30px 30px;
    margin: 50px 35px 24px;
    text-align: left;
    .title{
        font-size: 18px;
        color: #36aafd;
    line-height: 30px;
    font-weight: normal;
    font-stretch: normal;
    }
    p{
        font-size: 16px;
        line-height: 30px;
    letter-spacing: 0px;
    color: #666666;
    }
    }
}
   .edit-from{
         margin-bottom: 44px;
         .public-tit{
            width: 100%;
            margin-bottom: 20px;
         }
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
           ::v-deep{
    .el-upload,.el-upload-dragger{
    background: none;
    border: none;
    height: auto;
   .icon-al-file-fill{
    font-size: 80px;
    color: #C0C4CC;
    margin: 0px 0 16px;
    }
    .el-button{
        margin-top: 30px;
    }
    }
 .el-dialog {
    margin-top: 5vh !important;
 }   
 .authbtn{
    margin-top: 30px;
    justify-content: center !important;
 }
}
</style>